var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/**
 * A pure function to pick specific keys from object, similar to https://lodash.com/docs/4.17.4#pick
 * @param {Object}obj: The object to pick the specified keys from
 * @param {Array}keys: A list of all keys to pick from obj
 */
export var pick = function (obj, keys) {
    return Object.keys(obj)
        .filter(function (i) { return keys.includes(i); })
        .reduce(function (acc, key) {
        acc[key] = obj[key];
        return acc;
    }, {});
};
/**
 * Checks if two objects are equal
 * @param x
 * @param y
 */
export var deepEqual = function (x, y) {
    var ok = Object.keys, tx = typeof x, ty = typeof y;
    return x && y && tx === 'object' && tx === ty
        ? ok(x).length === ok(y).length && ok(x).every(function (key) { return deepEqual(x[key], y[key]); })
        : x === y;
};
/**
 *
 * @param key
 * @param obj
 */
export var omit = function (key, obj) {
    var _a = obj, _b = key, omitted = _a[_b], rest = __rest(_a, [typeof _b === "symbol" ? _b : _b + ""]);
    return rest;
};
/**
 * Returns a new object without specified keys in params
 * @param obj
 * @param keys
 */
export var omitKeys = function (obj, keys) {
    var newObj = {};
    Object.keys(obj).forEach(function (key) {
        if (!keys.includes(key)) {
            newObj[key] = obj[key];
        }
    });
    return newObj;
};
